/** A bathroom scale outline, for the nav. Decorative; the nav label carries the name. */
export function WeightIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      aria-hidden="true"
      className={className}
    >
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M8 9.5a4 4 0 0 1 8 0" strokeLinecap="round" />
      <path d="M12 9.5l1.6-2" strokeLinecap="round" />
    </svg>
  );
}
